<template>
    <div class="container-default p-5" v-if="compra">
        <div class="pdf-content" style="height: 130px; min-width: 800px" id="header">
            <div class="row bg-white border border-dark">
                <table class="table table-borderless w-100">
                    <tbody>
                        <tr>
                            <td class="text-left" style="width:30%">
                                <img v-if="image" :src="image" alt="LOGO" height="45px" >
                            </td>
                            <td class="text-center" style="width: 50%;">
                                <h6>{{ compra.filial[0].nome }}</h6>
                                <span>PEDIDO DE COMPRA Nº {{ compra.npedido }}</span>
                                <br v-if="compra.status === 'C'"><span v-if="compra.status === 'C'" class="badge badge-danger">CANCELADO</span>
                            </td>
                            <td class="text-right" style="width: 20%">
                                Data: {{ compra.data | formatData() }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="pdf-content" style="min-width: 800px" id="body">
            <div class="row bg-white border-bottom border-left border-right border-dark">
                <table class="table table-borderless table-sm w-100 mb-0">
                    <tbody>
                        <tr>
                            <td colspan="2">
                                <span><strong>Fornecedor:</strong> {{ compra.part[0].nome }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td width="60%">
                                <span><strong>CNPJ:</strong> {{ compra.part[0].cnpjcpf | formatCNPJCPF }}</span>
                            </td>
                            <td width="40%">
                                <span><strong>Telefone:</strong> {{ compra.part[0].fone_contato || compra.part[0].fone1 }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <span><strong>Email:</strong> {{ compra.part[0].emaildanfe }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <span>
                                    <strong>Endereço:</strong>
                                    {{ compra.part[0].ende }} {{ compra.part[0].endenr }} {{ compra.part[0].endecomp }} - {{ compra.part[0].bairro }} - {{ compra.part[0].nomemun }} - {{ compra.part[0].uf }} - CEP {{ compra.part[0].cep }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div style="overflow-x: scroll;" class="row flex-column bg-white border-right border-left border-dark" v-if="compra.comprait && compra.comprait.length > 0">
                <table class="table table-sm table-bordered tb-detalhes-produto mb-0">
                    <thead>
                        <tr style="font-size: 10px">
                            <th scope="col"> Produto</th>
                            <th scope="col" width="100" class="text-center">Preço Unitário</th>
                            <th scope="col" width="100" class="text-center">Quantidade</th>
                            <th scope="col" width="100" class="text-center">Subtotal</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in compra.comprait" :key="i">
                            <td width="55%">
                                {{ item.refitem }} - {{ item.dscitem }}
                                <div v-if="item.obsitem" class="mt-1 small">
                                    <strong>Obs:</strong> {{ item.obsitem }}
                                </div>
                            </td>
                            <td class="text-right">R${{ item.preco | formatValue(2,true) }}</td>
                            <td class="text-right">{{ item.quantidade | formatValue(2,true) }} <strong class="ml-1">{{item.unidade}}</strong></td>
                            <td class="text-right">R${{ item.total | formatValue(2,true) }}</td>
                        </tr>
                   </tbody>
                </table>
            </div>

            <div class="row bg-white border-top border-right border-left border-dark d-flex justify-content-end">
                <table class="ml-auto">
                    <tr v-if="compra.vlrfrete">
                        <th class="px-3 text-right" width="150">Frete</th>
                        <td class="text-right pr-1" width="150">R$ {{ compra.vlrfrete | formatValue(2, true) }}</td>
                    </tr>
                    <tr v-if="compra.totdesc">
                        <th class="px-3 text-right" width="150">Descontos</th>
                        <td class="text-right pr-1" width="150">R$ {{ compra.totdesc | formatValue(2, true) }}</td>
                    </tr>
                    <tr>
                        <th class="px-3 text-right" width="150">Total do Pedido</th>
                        <td class="text-right pr-1" width="150">R$ {{ compra.totpedido | formatValue(2, true) }}</td>
                    </tr>
                </table>
            </div>

            <div class="row bg-white border-top border-bottom border-left border-right border-dark">
                <table class="table table-borderless table-sm w-100 mb-0 p-1">
                    <tbody>
                        <tr>
                            <td width="60%" class="text-left">
                                <span>
                                    <strong>Transportadora:</strong>
                                    {{ compra.parttr.length ? compra.parttr[0].nome : '' }}
                                </span>
                            </td>
                            <td width="40%" class="text-left">
                                <span>
                                    <strong>Frete:</strong>
                                    {{ formatFrete(compra.tipofrete) }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="row bg-white border-bottom border-left border-right border-dark">
                <div class="col-md-12 d-flex flex-column p-2">
                    <span><strong>Solicitante:</strong> {{ compra.usuario_nome }} </span>
                </div>
            </div>
            <div v-if="compra.comprapar && compra.comprapar.length > 0" class="row bg-white border-bottom border-left border-right border-dark">
                    <table class="table table-borderless table-sm w-50 mb-0">
                        <tbody>
                            <tr>
                                <td>
                                    <table class="table table-borderless table-sm mb-0">
                                        <thead>
                                            <tr>
                                                <th scope="col">Vencimento: </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, i) in compra.comprapar" :key="i">
                                                <td class="text-left">
                                                    <span>{{ item.dtvenc | formatData }}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <td>
                                    <table class="table table-borderless table-sm">
                                        <thead>
                                            <tr>
                                                <th scope="col">Valor Parcela: </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, i) in compra.comprapar" :key="i">
                                                <td class="text-left">
                                                    <span>R${{ item.valor | formatValue(2) }}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
            </div>
            <div class="row bg-white border-bottom border-left border-right border-dark" v-if="compra.obs">
                <div class="col-md-12 p-2" style="width: 95%; white-space: pre-line">
                    <strong>Observações: </strong>
                    {{ compra.obs }}
                </div>
            </div>
            <div class="row bg-white">
                <div class="col-md-12" style="min-height: 100px">
                    <br>
                    <span><strong>Assinatura / Aprovado </strong> </span>
                    <span><strong>______________________________________________________</strong></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        index: null,
        compra: null,
        uuid: null,
        image: null
    },
    methods: {
        formatFrete(tipo) {
            const types = {
                'R': 'Remetente (CIF)',
                'D': 'Destinatário (FOB)',
                'S': 'Sem Frete'
            }
            return types[tipo] || tipo
        },
        getHtmlContent() {
            setTimeout(() => {
                const contentHeader = document.getElementById('header').innerHTML
                const contentBody = document.getElementById('body').innerHTML
                const htmlContent = [contentHeader, contentBody]
                this.$emit('handleHtmlContent', htmlContent)
            }, 1000);
        }
    }
}
</script>

<style>
div.page_break + div.page_break{
    page-break-before: always;
}
.wrapper-page {
    page-break-after: always;
}

.wrapper-page:last-child {
    page-break-after: avoid;
}
</style>



// WEBPACK FOOTER //
// src/forms/pedido-compra-content-pdf.vue